import type { ReactNode } from "react";
import { SettingsNav, type SettingsNavItem } from "./SettingsNav";

interface SettingsLayoutProps {
  nav: SettingsNavItem[];
  activeId: string;
  onSelect: (id: string) => void;
  children: ReactNode;
}

export function SettingsLayout({
  nav,
  activeId,
  onSelect,
  children,
}: SettingsLayoutProps) {
  return (
    <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
      <aside className="lg:w-60 lg:shrink-0 lg:sticky lg:top-6">
        <SettingsNav items={nav} activeId={activeId} onSelect={onSelect} />
      </aside>
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  );
}
